require("./orderDetails.less");
import {LoDashStatic} from "lodash";
import * as _ from 'lodash';

class OrderDetailsController {
    order;
    promise;
    orderLines: Array<any>;
    canConfirmOrder: boolean;

    //--- Table-definition ---------------------------------------------------
    iconColumn = {title: '', name: '', noOrderBy: true};
    tableDefinition: Array<any> = [
        this.iconColumn,
        this.iconColumn,
        {title: 'Varenr', name: 'articleNo', type: 'text'},
        {title: '', name: ''},
        {title: '', name: ''},
        {title: 'Vare', name: 'articleName', type: 'text'},
        {title: 'I ordre', name: 'quantity', type: 'number'},
        {title: 'På lager', name: 'unitInStock', type: 'number'},
        {title: 'Disp. lager', name: 'available', type: 'number'},
        this.iconColumn,
        {title: 'Tilgjengelig', name: 'availableFromDate', type: 'text'},
        {title: '', name: '', isConfirmCheck: true},
        {title: 'Bekr. dato', name: 'deliveryDate', type: 'text'},
        {title: 'Splitt linje', name: ''}
    ];

    toolbarheaderDefinition = {
        isTable: true,
        toolbarHeading: null,
        previousStateArrowActive: true,
    };

    constructor(private toastService, private Orders, private $mdDialog, hasAccessTo, private $state) {
        this.canConfirmOrder = hasAccessTo.orderConfirmation();
    }

    $onInit() {
        this.getDetails()
    }

    getDetails() {
        var orderNo = this.$state.params.orderNo;
        this.promise = this.Orders.getOrderDetails({orderNumber: orderNo}, {}).$promise.then(
            (results) => {
                this.order = results;
                const orderLines = results.orderLines.map(orderLine => {
                    orderLine.deliveryDate = orderLine.deliveryDate ? new Date(orderLine.deliveryDate) : null;
                    orderLine.routeDaysString = orderLine.routeDays.toString();
                    return orderLine;
                });
                this.orderLines = _.orderBy(orderLines, orderLine => orderLine['confirmedAlert'], ["RED", "YELLOW"]);
                this.order.parsedRouteDays = OrderDetailsController.toDaysString(this.order.routeDays);
                this.toolbarheaderDefinition.toolbarHeading = results.orderNo + " - " + results.customer.name + " (" + results.customer.customerNo + ")";
            },
            (error) => {
                this.promise = null;
                if (error.status === 404) {
                    this.toastService.showReturnToast("Ordren finnes ikke", 10000);
                } else {
                    this.toastService.parseError(error);
                }

            }
        );
    }

    /**
     *  routeDays are represented as a number and each number corresponds to a day.
     *  1 -> monday, 3 -> wednesday etc.
     *  0 = every day
     */
    private static toDaysString(days: number) {
        function asDayString(dayNumber: string) {
            switch (dayNumber) {
                case "1":
                    return "Ma";
                case "2":
                    return "Ti";
                case "3":
                    return "On";
                case "4":
                    return "To";
                case "5":
                    return "Fr";
                case "6":
                    return "Lø";
                case "7":
                    return "Sø";
                default:
                    return null;
            }
        }

        return days === 0
            ? "Alle"
            : _.map(days.toString(), asDayString).join(", ");
    }

    openConfirmationDialog(event) {
        var hasUnconfirmedOrderLines = _.some(this.order.orderDetails, (orderLine: any) => !orderLine.confirmedDate);
        var confirm = this.$mdDialog.confirm()
            .title(this.order.orderNo)
            .textContent(hasUnconfirmedOrderLines ? "NB! Orderen har ordrelinje(r) uten bekreftet dato!" : "Bekreft ordre")
            .ariaLabel('confirmationdialog')
            .targetEvent(event)
            .ok("Bekreft")
            .cancel('Avbryt');
        this.$mdDialog.show(confirm).then(() => {
            this.Orders.confirmOrder({orderNumber: this.order.orderNo}, {}).$promise.then(
                () => {
                    this.toastService.showSimpleToast("Ordren har blitt bekreftet!", 3000);
                    this.$mdDialog.hide();
                },
                (errorResponse) => this.toastService.parseError(errorResponse)
            );
        }, () => {
        });
    }
}

class OrderDetailsOptions implements ng.IComponentOptions {
    controller = 'rkcOrderDetailsController';
    controllerAs = "c";
    template: any = require('./orderDetails.html');
}

rkcApp.controller("rkcOrderDetailsController", ['toastService', 'Orders', '$mdDialog', 'hasAccessTo', '$state',
    function (toastService, Orders, $mdDialog, hasAccessTo, $state) {
        return new OrderDetailsController(toastService, Orders, $mdDialog, hasAccessTo, $state);
    }])
    .component("rkcOrderDetails", new OrderDetailsOptions())
;



/** WEBPACK FOOTER **
 ** ./src/app/components/main/views/orderDetails/orderDetails.ts
 **/